const transformed = (input) => {
  // Parse config if it's a string (from Contentful JSON field)
  let config = input.config;
  if (typeof config === 'string') {
    try {
      config = JSON.parse(config);
    } catch (e) {
      console.error('Failed to parse calculator config:', e);
      config = {};
    }
  }

  return {
    ...input,
    config: config || {}
  };
};

export default transformed;
